import React from "react";
import useFinancialData from "../financial/useFinancialData";
import { formatNumber, getFinancialTotals } from "../financial/utils";
import WrapErrorLoading from "../../shared/components/WrapErrorLoading";
import { getIconClass } from "../utils";
import { gettext } from "../../shared/utils/legacy";
import cropr from "../../shared/utils/cropr";
import DashboardSummaryInfo from "./DashboardSummaryInfo";

function BalanceComponent() {
  const { data, error } = useFinancialData({});
  const [costs, revenues] = getFinancialTotals(data);
  if (isNaN(revenues - costs)) return <>-</>;
  return (
    <WrapErrorLoading error={error}>
      {() =>
        data && (
          <>
            <i className={getIconClass(revenues >= costs)} />
            &nbsp;
            {formatNumber(revenues - costs, true, false, 0)}
          </>
        )
      }
    </WrapErrorLoading>
  );
}

const DashboardSummaryBalance = () => {
  // - Je staat in - of +
  // klik: naar saldooverzicht
  // upsell als je geen pro hebt
  return (
    cropr.permissions.isOwner && (
      <div className="col-4 col-md py-3">
        <h6 className="text-muted mb-3">{gettext("Balance")}</h6>
        {(cropr.features.pro && (
          <a
            href={"/cropr/dashboard/#financial/"}
            title={gettext("Go to financial overview")}
            className="text-black"
            data-metrics_category="summary_widget"
            data-metrics_sub_category="financial_overview"
          >
            <BalanceComponent />
          </a>
        )) || (
          <DashboardSummaryInfo
            href="https://www.dacom.nl/nl/producten/teeltregistratie/"
            category="financial"
          />
        )}
      </div>
    )
  );
};

export default DashboardSummaryBalance;
